import Skeleton from '@mui/material/Skeleton';
import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { Stack } from 'shared/mui/Stack/Stack';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';

export const MethodsShowSkeleton = () => (
  <>
    <Stack direction="row" gap={1} sx={{ marginBottom: '24px' }}>
      {Array.from({ length: 4 }).map((_, i) => (
        <Skeleton height={24} key={i} variant="rounded" width={80} />
      ))}
    </Stack>
    <CardTable tableBodyProps={{ sx: { '& td': { width: '136px' } } }}>
      {Array.from({ length: 3 }).map((_, i) => (
        <TableRowWrapper key={i} label={<Skeleton />}>
          <Skeleton />
        </TableRowWrapper>
      ))}
      <TableRowWrapper label={<Skeleton />}>
        <Skeleton height={32} variant="rounded" width={48} />
      </TableRowWrapper>
    </CardTable>
  </>
);
